module.exports = __webpack_public_path__ + "static/ilustracao-pedido-compra-8aa26371e5adacb0ee9fb8e98ac5cacb.svg";